import { render, staticRenderFns } from "./Army.vue?vue&type=template&id=5c4ccaf7&"
import script from "./Army.vue?vue&type=script&lang=js&"
export * from "./Army.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports